import * as Firebase from 'firebase';

export default async function() {

  await Firebase.auth().signOut();

}



// WEBPACK FOOTER //
// ./src/services/firebaseLogout.ts